import { OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import DefaultColumnFilter from './datatable.columnfilter'

import { QIR } from '../Types/QIR';

interface QirColumnProps {
    header: string,
    accessor: string,
    qirs: QIR[]
}

function QirColumn({ header, accessor, qirs }: QirColumnProps) {

    if (accessor === undefined) {
        throw new Error("QirColumn requires an accessor");
    }

    return {
        Header: header,
        accessor: accessor,
        filter: 'includesString',
        Filter: DefaultColumnFilter,
        Cell: ({ value }: any) =>
            <div className="d-flex justify-content-center">{
                value.map((qirIncidentId: string) => {
                    let q: QIR | undefined = qirs.find((q) => q.incidentId === qirIncidentId);

                    if (q) {
                        let header: string = qirIncidentId as string;

                        if (q.clientQirId != null && q.clientQirId !== "") {
                            header += " / " + q?.clientQirId;
                        }

                        let s: string = q.statement as string;

                        let popover = (
                            <Popover>
                                <Popover.Header as="h3">{header}</Popover.Header>
                                <Popover.Body>
                                    {s}
                                </Popover.Body>
                            </Popover>
                        );
                        return (<OverlayTrigger overlay={popover}>
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            </OverlayTrigger>)
                    }
                }
                )}
            </div>,
        className: "w-auto"
    };
}

export default QirColumn;